import { render, staticRenderFns } from "./details.vue?vue&type=template&id=9993ccc2&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=9993ccc2&prod&lang=css"
import style1 from "./details.vue?vue&type=style&index=1&id=9993ccc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9993ccc2",
  null
  
)

export default component.exports